module.exports = __webpack_public_path__ + "img/info7.9a014c1a.png";